module.exports = __webpack_public_path__ + "static/img/sy_1.bde46b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/sy_1.png
// module id = t5EV
// module chunks = 1